module.exports = __webpack_public_path__ + "img/bg_di@2x.c25d17e6.png";